import { useQueryClient } from 'react-query';
import { queryMeKey } from 'src/services/queries/useMeQuery';
import { RetrieveMyInformationResponse } from 'src/types';

export const useCurrentUser = () => {
  const client = useQueryClient();

  return client.getQueryCache().find<RetrieveMyInformationResponse>(queryMeKey)?.state?.data;
};
